module.exports = __webpack_public_path__ + "static/media/9.Shooting Star.5c0c6997.gif";